/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";
import { useSelector } from "store";
import { LiveCommercePaymentMethodConfirm } from "ui/Streaming/LiveCommerce/LiveCommercePaymentMethodConfirm";

import { StreamingLiveCommerceAddressV2 } from "./StreamingLiveCommerceAddressV2";
import { StreamingLiveCommerceAmountV2 } from "./StreamingLiveCommerceAmountV2";
import { StreamingLiveCommerceCartLayoutV2 } from "./StreamingLiveCommerceCartLayoutV2";
import { StreamingLiveCommerceItemListV2 } from "./StreamingLiveCommerceItemListV2";

import type { PayType } from "@spwn/types";
import type { ProductData } from "@spwn/types/firebase/firestore";
import type { AddressInfo } from "modules/auth";
import type { Store } from "store";
import type { EventInfo } from "utility";

type Props = {
  playerHeight: number;
  addressInfo: AddressInfo | null;
  paymentMethod: PayType;
  pseudoCart: (ProductData & { count: number })[];
  displayEvent: EventInfo;
  cartTotalFee: number;
  shippingFee: number;
  settlementFee: number;
  totalFee: number;
  handleBackToCart: () => void;
  handlePurchase: () => void;
  decrementCartItem: (itemData: ProductData) => void;
  incrementCartItem: (itemData: ProductData) => void;
};

const StreamingLiveCommerceCartConfirmV2: React.FC<Props> = (props) => {
  const isDarkModeEnabled = useSelector(
    (state: Store) => state.streaming.streamingSettings.isDarkModeEnabled
  );

  const { t } = useI18n();
  const paymentMethodValues: { [key: string]: string } = {
    Card: t("streaming.commerceCart.paymentCard"),
    CVS: t("streaming.commerceCart.paymentCvs"),
    Phone: t("streaming.commerceCart.paymentPhone"),
  };
  const paymentMethodValue = paymentMethodValues[props.paymentMethod] ?? "";

  const addressSection = (
    <StreamingLiveCommerceAddressV2 addressInfo={props.addressInfo} />
  );
  const paymentSection = (
    <LiveCommercePaymentMethodConfirm
      isDarkModeEnabled={isDarkModeEnabled}
      paymentMethodValue={paymentMethodValue}
      onClick={props.handleBackToCart}
    />
  );

  const cartLabel = t("streaming.commerceCart.order");
  const itemListSection = (
    <StreamingLiveCommerceItemListV2
      pseudoCart={props.pseudoCart}
      THEOPlayerElementHeight={props.playerHeight}
      isDarkModeEnabled={isDarkModeEnabled}
      displayEvent={props.displayEvent}
      incrementCartItem={props.incrementCartItem}
      decrementCartItem={props.decrementCartItem}
    />
  );
  const summarySection = (
    <StreamingLiveCommerceAmountV2
      isDarkModeEnabled={isDarkModeEnabled}
      cartTotalFee={props.cartTotalFee}
      shippingFee={props.shippingFee}
      settlementFee={props.settlementFee}
      totalFee={props.totalFee}
      isCalculatingShippingFee={false}
    />
  );

  return (
    <StreamingLiveCommerceCartLayoutV2
      isDarkMode={isDarkModeEnabled}
      playerHeight={props.playerHeight}
      addressSection={addressSection}
      paymentSection={paymentSection}
      cartLabel={cartLabel}
      itemListSection={itemListSection}
      summarySection={summarySection}
      handleBackButton={props.handleBackToCart}
    />
  );
};
export default StreamingLiveCommerceCartConfirmV2;
